$ = jQuery;

// Console.log fix
if ( typeof console == 'undefined' ) {
  console = {};
}
if ( typeof console.log == 'undefined' ) {
  console.log = function () {}
}
if ( typeof console.error == 'undefined' ) {
  console.error = function () {}
}

var $html = null;
var $body = null;
var $site = null;
var fz;

$(document).ready(function() {
  $body = $('body');
  $html = $('html');
  $site = $('#site-content');

  if ( is_webkit() ) {
    $body.addClass('webkit');
  }
  $body.addClass('body-ready');

  $(window).resize();
});

$(window).on('load',function() {
  $('body').addClass('page-loaded');
  $(window).resize();
  setTimeout(function() {
    $(window).resize();
  },500);
});
window.addEventListener("orientationchange", function() {
  $(window).resize();
}, false);

$(window).resize(function() {
  // Font size
  if ( $site ) {
    if ( $site.length ) {
      var w = $site.width();
      if ( !is_mobile() ) {
        if ( w < 1024 ) {
          //w = 1024;
        }
        fz = w / 1640;
        if ( fz > 1 ) {
          fz = 1;
        }
      } else {
        if ( w > 640 ) {
          w = 640;
        }
        fz = w / 400;
      }
      $html.css('font-size', ( fz * 100 ) + '%');
      $('.js-fz').css('transform','scale('+fz+')');
    }
  }
  $(window).scroll();
});
Drupal.behaviors.sw_resize = {
  attach: function( context, settings ) {
    $(window).resize();
  }
}


function is_mobile () {
  return $('#mobile-detect').is(':visible');
}
function is_webkit () {
  return "webkitLineBreak" in document.documentElement.style;
}
function wait () {
  return '<div class="wait"><b></b><b></b><b></b><b></b></div>';
}
function remove_wait ( $wrap ) {
  $wrap.find('.wait').fadeOut(200, function () {
    jQuery(this).remove();
  });
}
function scrollto ( $elem ) {
  let scroll_to = typeof $elem == 'number' ? $elem : $elem.offset().top;
  let st = $(window).scrollTop();
  let ot = scroll_to - (scroll_to < st ? $('.header').height() : 0);
  jQuery('body,html').animate({
    scrollTop: ot,
  }, {
    duration: 500
  });
}

// Messages
$(document).on('click', '.drupal-messages .close', function () {
  var $m = $(this).closest('.drupal-messages');
  $m.slideUp(500);
});
Drupal.behaviors.sw_messages_theme = {
  attach: function( context, settings ) {
    $('.drupal-messages-page-wrap .drupal-messages').once('sw_messages').each(function() {
      $(this).addClass('processed');
      $(this).append('<span class="close"></span>');
    });
  }
};

// AJAX Throbber override
setTimeout(function() {
  Drupal.theme.ajaxProgressThrobber = function () {
    return '<div class="sw-ajax-form-wrap-overlay">'+wait()+'</div>';
  };

  if ( typeof Drupal.AjaxCommands !== 'undefined' ) {
    // Override scroll top to offset header
    Drupal.AjaxCommands.prototype.viewsScrollTop = function( ajax, response ) {
      var offset = $(response.selector).offset();
      var $header = $('.header-pad');
      var scroll_to = offset.top - $header.height() - 50;
      var scrollTarget = response.selector;

      while ( $(scrollTarget).scrollTop() === 0 && $(scrollTarget).parent() ) {
        scrollTarget = $(scrollTarget).parent();
      }

      if ( scroll_to < $(scrollTarget).scrollTop() ) {
        $(scrollTarget).animate({
          scrollTop: scroll_to
        }, 500);
      }
    };
  }
}, 100);

// Scroll Down
$(document).on('click', 'a[href*="#"]', function( e ) {
  let $a = $(this);
  if ( e.isDefaultPrevented()) {
    return false;
  }
  var regex = /#(.*)$/gi;
  var href = $a.attr('href');
  var m = regex.exec(href)
  if ( m ) {
    var id = m[1];
    var $block = $('#' + id);
    if ( $block.length ) {
      e.preventDefault();
      scrollto($block);
    }
  }
});

Drupal.behaviors.sw_webform = {
  attach: function( context, settings ) {
    if ( !Drupal.webform ) {
      Drupal.webform = {};
    }
    Drupal.webform.scrollTopOffset = 300;
  }
}

let pst = null;
$(window).scroll(function() {
  let st = $(window).scrollTop();
  if ( st > 200 ) {
    $('body').addClass('body--header-scrolled');
  } else {
    $('body').removeClass('body--header-scrolled');
  }
  if ( st > 200 && pst !== null && pst < st ) {
    $('body').addClass('body--header-scrolled-down');
  } else {
    $('body').removeClass('body--header-scrolled-down');
  }
  pst = st;
});

// Menu
$(document).on('click', '.header__menu .expander',function(e) {
  if ( !is_mobile()) {
    return;
  }
  let $li = $(this).closest('li');
  e.preventDefault();
  e.stopPropagation();
  let was_open = $li.hasClass('open');
  $li.parent().find('li.open').removeClass('open').find('ul').slideUp(300);
  if ( !was_open ) {
    $li.addClass('open').find('ul').slideDown(300);
  }
});
$(document).on('click', '.header__menu-opener', function() {
  $('.header').toggleClass('header--menu-open');
});
$(document).on('click', '.header__menu', function(e) {
  if ( !$(e.target).is('.header__menu > ul')
    && !$(e.target).closest('ul').closest('.header__menu').length ) {
    $('.header').removeClass('header--menu-open');
  }
});

// Wow
new WOW({
  mobile: false,
}).init();

// Lines resize
$(window).resize(function() {
  $('.line').each(function() {
    let $l = $(this);
    let $p = $l.parent();
    let req_w = $p.outerWidth();
    if ( $l.hasClass('line--full')) {
      return;
    } else if ( $l.hasClass('line--tl') || $l.hasClass('line--lb')) {
      req_w += $p.offset().left - $l.offset().left;
    } else {
      req_w += -(($p.offset().left + $p.outerWidth()) - ($l.offset().left + $l.outerWidth()));
    }
    let req_h = $p.outerHeight();
    if ( $l.hasClass('line--tl') || $l.hasClass('line--tr')) {
      req_h += $p.offset().top - $l.offset().top;
    } else {
      req_h += -(($p.offset().top + $p.outerHeight()) - ($l.offset().top + $l.outerHeight()));
    }
    let w = Math.max(req_w, req_h);
    $l.width(w);
  });
});

// Chat bot
$(window).scroll(function() {
  let st = $(window).scrollTop();
  let wh = $(window).height();
  let $chat = $('.rmiq-chat-button');
  let $footer = $('footer');
  let $chat_spacer = $('.rmiq-chat-button__spacer');
  if ( st + wh > $footer.offset().top + $chat_spacer.height() ) {
    $chat.addClass('rmiq-chat-button--absolute');
  } else {
    $chat.removeClass('rmiq-chat-button--absolute');
  }
});

// Footer subscribe inactive on subscribe page
Drupal.behaviors.sw_footer_subscribe = {
  attach: function( context, settings ) {
    $('.footer__subscribe').each(function() {
      let $a = $(this);
      if ( $a.attr('href') === location.href ) {
        $a.hide();
      }
    });
  }
}

// Use iframe dialogs
Drupal.behaviors.sw_use_iframes = {
  attach: function( context, settings ) {
    $('a.use-iframe').once('sw_use_iframes').each(function() {
      $(this).click(function(e) {
        e.preventDefault();
        let $a = $(this);
        let $iframe = $('<iframe>');
        $iframe.attr('src', $a.attr('href'));
        Drupal.dialog($iframe, {
          dialogClass: $a.data('dialog-class'),
        }).showModal();
      });
    });
  }
}

// Header search
Drupal.behaviors.sw_header_search = {
  attach: function( context, settings ) {
    $('.header').once('sw_header_search').each(function() {

      $('.header__search').on('click', function(e) {
        e.preventDefault();
        if ( $body.hasClass('body--search-open')) {
          $body.removeClass('body--search-open');
        } else {
          $body.addClass('body--search-open');
          $('#search input').focus();
        }
      });

      $('.header__search-drop__close').on('click', function() {
        $body.removeClass('body--search-open');
      });

    });
  }
}

// Header pad resize
$(window).resize(function() {
  $('.header-pad').height($('.header').outerHeight());
});

// anchor link scroller
$('.countySelector').on('change', function() {
  var myCounty = $(this).val();
  document.querySelector('#' + (myCounty)).scrollIntoView({
    behavior: 'smooth'
  });
});

//section expand and collapse
function sectionCollapse(id) {
  $(id).toggleClass("togglehide");
};
